import { FC, useMemo } from "react";

import { SKU } from "@/data/types";
import { useFormValues } from "@/hooks/use-form-values";
import { SKUFormValues } from "@/lib/forms";
import { getFirstUniqueContentRow } from "@/lib/preview";

import { PreviewExperience } from "./preview-experience";
import { WebpageAttributes } from "./webpage-attributes";
import { WebpageBuilderSelector } from "./webpage-builder-selector";

type Props = {
  sku: SKU;
};

export const WebExperienceTab: FC<Props> = ({ sku }) => {
  const values = useFormValues<SKUFormValues>();

  const params = useMemo(() => {
    return {
      ...values,
      page_type: sku.page_type,
      page_content: sku.page_content,
      unique_content: getFirstUniqueContentRow(sku.unique_content),
    };
  }, [values, sku.page_type, sku.page_content, sku.unique_content]);

  return (
    <div className="flex flex-col lg:flex-row gap-6 pt-4">
      <div className="flex-none lg:flex-1 lg:min-w-[320px] space-y-6">
        <WebpageBuilderSelector skuId={sku.id} pageType={sku.page_type} />
        <WebpageAttributes
          skuId={sku.id}
          pageType={sku.page_type}
          pageContent={sku.page_content}
          availableLoginOptions={sku.available_login_options}
        />
      </div>
      <PreviewExperience params={params} />
    </div>
  );
};
